import React, { useCallback } from 'react';
import { AppButton, Preloader } from '@common-fe/common-fe';

import { useEditMode } from '../../../hooks';
import { useSavePayoutDefinitionStore } from '../stores/useSavePayoutDefinition.store';

const TopbarSaveButton: React.FC = () => {
  const { isEditMode, activateEditMode } = useEditMode();
  const handleSave = useSavePayoutDefinitionStore((state) => state.handleSave);
  const isLoading = useSavePayoutDefinitionStore((state) => state.isLoading);

  const onClick = useCallback(() => {
    if (isEditMode) {
      handleSave?.();
    } else {
      activateEditMode();
    }
  }, [isEditMode, handleSave, activateEditMode]);

  return (
    <AppButton
      testId="topbar_save-button"
      color="blue"
      size="M"
      width="134px"
      buttonType={isEditMode ? 'primary' : 'secondary'}
      onClick={onClick}
      disabled={isEditMode && (isLoading || !handleSave)}
    >
      {isEditMode ? isLoading ? <Preloader /> : 'Save' : 'Edit'}
    </AppButton>
  );
};

export default TopbarSaveButton;
